export default __webpack_public_path__ + "static/media/livingroom1.da9986cd.jpg";